<template>
    <div>
        <el-tabs style="width: 100%" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="美团民宿" name="1"></el-tab-pane>
            <el-tab-pane label="途家" name="2"></el-tab-pane>
            <el-tab-pane label="小猪" name="3"></el-tab-pane>
            <div class="tableForm">
                <el-input style="width: 260px;" size="small" v-model="input" placeholder="请输入房源名称"></el-input>
                <el-button type="" size="small" style="margin-left: 10px;" @click="getData(1)">查询</el-button>
                <span style="margin-left: 10px;">已关联: 18</span>
                <span style="margin-left: 10px;">未关联: 0</span>
                <span style="margin-left: 10px;">关联异常: 0</span>
            </div>


            <el-table :data="tableData" v-loading="tableLoading" style="width: 100%;margin-top: 30px;">
                <el-table-column label="房源名称" width="400">
                    <template slot-scope="scope">
                        <div style="display: flex;justify-content: left;align-items: center">
                            <img :src="scope.row.picture " style="width: 80px;height:auto;border-radius: 15px" alt="">
                            <p style="margin-left: 10px;font-size: 14px;font-weight: 500">{{ scope.row.roomTitle }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="渠道账号" width="160">
                    <template slot-scope="scope"> {{ scope.row.username }}</template>
                </el-table-column>
                <el-table-column label="库存" width="100">
                    <template slot-scope="scope">
                        {{ scope.row.inventory }}
                    </template>
                </el-table-column>
                <el-table-column label="关联状态" width="180">
                    <template slot-scope="scope">
                        <el-tag size="medium" :type="scope.row.mt?'success':'danger'">
                            {{ scope.row.mt ? '已关联' : '未关联' }}
                        </el-tag>
                    </template>
                </el-table-column>
<!--                <el-table-column align="right" label="">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.row)">  {{ scope.row.mt ? '解除关联' : '关联' }}</el-button>
                        <el-button size="mini" @click="handleDelete(scope.$index, scope.row)">···</el-button>
                    </template>
                </el-table-column>-->
            </el-table>
            <div style="text-align: center;margin-top: 20px;">

                <el-pagination :current-page="pageNum" @current-change="pageChange" background
                               layout="prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </el-tabs>
    </div>
</template>

<script>
import {correlation, disassociate, findByPage} from "@/api/index.js"

export default {
    name: 'allListings',

    data() {
        return {
            activeName: '1',
            tableData: [],
            input:'',
            pageNum: 1,
            pageSize: 10,
            total: 0,
            tableLoading:false
        };
    },

    mounted() {
        this.getData();
    },

    methods: {
        handleClick(index) {
            console.log(this.activeName)
            if (this.activeName!='1')
            {
                this.tableData = [];
            }
            else
            {
                this.getData();
            }
        },
        getData(pageNum = 1) {
            this.tableLoading = true;
            this.pageNum = pageNum;
            findByPage({
                roomTitle:this.input
            }, {
                pageNum: this.pageNum,
                pageSize: this.pageSize
            }).then(res => {
                console.log(res.data)
                if (res.data.code === 200) {
                    this.tableData = res.data.data.recode;
                    this.total = res.data.data.total
                    this.tableLoading = false;
                }

            })
        },
        pageChange(index) {
            this.getData(index)
        },
        async handleEdit(item){
            console.log(item)
            let res = {}
            if(item.mt){
              res = await disassociate({ houseId: item.houseId })
                if (res.data.code === 200) {
                    this.$message({type: "success", message: '解除关联成功'})
                } else {
                    this.$message({type: "error", message: res.data.msg})
                }

            }else {
                res = await correlation(item)
                if (res.data.code === 200) {
                    this.$message({type: "success", message: '关联成功'})
                } else {
                    this.$message({type: "error", message: res.data.msg})
                }

            }
            this.getData();
        }
    },
};
</script>

<style lang="less" scoped>
/deep/ .el-tabs__item {
    font-size: 16px;
    width: auto;
    margin-bottom: 5px;
}

.tableForm {
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 14px;
}
/deep/ .el-table__header{
    width: 100% !important;
}
/deep/ .el-table__body{
    width: 100% !important;
}
</style>
